import { queryOptions } from '@tanstack/react-query';

import { fetchShopByUsername } from './api';

import { RQ_SHOP_USERNAME_KEY } from '@/modules/ReactQuery/cacheKeys';

export function shopByUsernameQueryOptions(username: string) {
  return queryOptions({
    queryKey: [RQ_SHOP_USERNAME_KEY, username],
    queryFn: () => fetchShopByUsername(username),
  });
}
